import React, { useEffect, useState } from "react";

const endOf = (iso) => new Date(`${iso}T23:59:59Z`).getTime();
const parts = (ms) => {
  const s = Math.max(0, Math.floor(ms / 1000));
  return { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
};

// Live "Sale ends in" countdown to the end of the sale's last day (UTC).
export const SaleCountdown = ({ endDate, testId = "sale-countdown", className = "" }) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  if (!endDate) return null;
  const left = endOf(endDate) - now;
  if (left <= 0) return null;
  const p = parts(left);
  const units = [["d", p.d], ["h", p.h], ["m", p.m], ["s", p.s]];
  return (
    <div data-testid={testId} className={`inline-flex items-center gap-3 ${className}`}>
      <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-[#9a7a80]">Sale ends in</span>
      <span className="inline-flex items-center gap-1.5">
        {units.map(([u, v]) => (
          <span
            key={u}
            data-testid={`${testId}-${u}`}
            className="inline-flex items-baseline gap-0.5 rounded-lg bg-[#FDFAF9] border border-[#8B2252]/15 px-2 py-1 font-display font-bold text-sm text-[#8B2252] tabular-nums"
          >
            {String(v).padStart(2, "0")}
            <span className="text-[9px] font-medium text-[#9a7a80]">{u}</span>
          </span>
        ))}
      </span>
    </div>
  );
};

export default SaleCountdown;
